module.exports = __webpack_public_path__ + "static/picture_a_2-5b7cf35f6850cc715e60f9ea34dbc0ba.jpg";